export class SetJobsLoadingStatus {
    public static readonly type = '[JobsPlacements] Set jobs loading status';
}
